export default __webpack_public_path__ + "271dbf3adbfedd73feb5cc538290abcf.png";